import { createComment } from './createComment'
import { createSubComment } from './createSubComment'
import { deleteComment } from './deleteComment'
import { getAllUserVideos } from './getAllUserVideos'
import { getArticles } from './getArticles'
import { getCategoriesArticles } from './getCategoriesArticles'
import { getComments } from './getComments'
import { likeVideo } from './likeVideo'
import { sendVideoToUser } from './sendVideoToUser'
import { updateAllCategoryVideosAsWatched } from './updateAllCategoryVideosAsWatched'
import { updateComment } from './updateComment'
import { updateWatched } from './updateWatched'

export const videosService = {
  createComment,
  createSubComment,
  deleteComment,
  getAllUserVideos,
  getComments,
  likeVideo,
  updateComment,
  updateWatched,
  sendVideoToUser,
  getArticles,
  getCategoriesArticles,
  updateAllCategoryVideosAsWatched,
}
